import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { getBrandLoginRedirect } from '@utils/get-brand-redirect';

import { getUrlToBackendApi, request } from '@services/api';

import { GET_ME_QUERY_KEY } from '@hooks/api/user/use-query-me';

const REQUEST_URL = '/login_by_site';

const MUTATION_KEY = ['auth', 'local-login'];

type LoginResponse = {
	meta: {
		access_token: string;
		refresh_token: string;
	};
};

export const useMutationLocalLogin = (shouldReload?: boolean) => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async ({ id }: { id: string }) => {
			const response = await request<LoginResponse>({
				method: 'post',
				url: getUrlToBackendApi(REQUEST_URL).href,
				data: {
					pm_id: id,
					phone: ''
				}
			});

			if (response?.meta?.access_token && response?.meta?.refresh_token) {
				localStorage.setItem('auth_token', response.meta.access_token);
				localStorage.setItem('refresh_token', response.meta.refresh_token);
			}

			return response;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });

			shouldReload && navigate(getBrandLoginRedirect(), { replace: true });
		},
		onError: error => {
			console.error('Error during login mutation:', error);
		}
	});
};
